module.exports = __webpack_public_path__ + "img/c12.42c85b79.png";